/* Carry the collection's selected performer into Shopify's actual variant selection. */
(() => {
  const PARAM = 'filter.p.m.custom.performers';
  const clean = (value) => String(value).trim().replace(/^\d+\s*[-–—]\s*/, '').replace(/\s+/g, ' ').toLocaleLowerCase();

  function applySelection(searchParams = window.location.search) {
    const names = [...new Set(new URLSearchParams(searchParams).getAll(PARAM).map(clean))];
    document.querySelectorAll('[data-limelight-product-variants]').forEach((script) => {
      let data;
      try { data = JSON.parse(script.textContent); } catch (_error) { return; }
      const position = data.options.findIndex((option) => /^(performance|performer|performers)$/i.test(option));
      if (position < 0) return;
      const candidates = data.variants.filter((variant) => names.includes(clean(variant.options[position])));
      // Do not guess if multiple selected names identify different performances in this section.
      const performances = new Set(candidates.map((variant) => variant.options[position]));
      let chosen;
      if (performances.size === 1) {
        const preferred = data.variants[0].options;
        const samePackage = (variant) => variant.options.every((option, index) => index === position || option === preferred[index]);
        chosen = candidates.find((variant) => variant.available && samePackage(variant)) ||
          candidates.find((variant) => variant.available) || candidates.find(samePackage) || candidates[0];
      }
      document.querySelectorAll(`[data-limelight-product-id="${data.id}"]`).forEach((element) => {
        const url = new URL(element.dataset.limelightProductUrl, window.location.origin);
        if (chosen) url.searchParams.set('variant', String(chosen.id));
        const target = url.pathname + url.search;
        if (element.tagName === 'A') element.setAttribute('href', target);
        else element.setAttribute('data-product-url', target);
      });
    });
  }

  if (window.limelightPerformerSelectionInstalled) return;
  window.limelightPerformerSelectionInstalled = true;
  window.addEventListener('limelight:filters-changed', (event) => applySelection(event.detail.searchParams));
  window.addEventListener('popstate', () => applySelection());
  const grid = document.getElementById('ProductGridContainer');
  if (grid) new MutationObserver(() => applySelection()).observe(grid, { childList: true, subtree: true });
  applySelection();
})();
